import { CommandIcon } from '@/../client-generator/generated-clients/plants';

export const getCommandIconFromType = (icon: CommandIcon) => {
  if (LettersCommandIcons.includes(icon))
    return `icon-letter-${CommandIcon[icon].toLowerCase()}`;
  else if (NumbersCommandIcons.includes(icon))
    return `icon-number-${CommandIcon[icon].toLowerCase()}`;
  return `icon-generic-${CommandIcon[icon].toLowerCase()}`;
};

export const SymbolsLightCommandIcons = [
  CommandIcon.Fan,
  CommandIcon.Ring,
  CommandIcon.Generic1,
  CommandIcon.Generic2,
  CommandIcon.Generic3,
  CommandIcon.Generic4,
  CommandIcon.Generic5,
  CommandIcon.Generic6,
  CommandIcon.Generic7,
  CommandIcon.Generic8,
  CommandIcon.Generic9,
  CommandIcon.Day,
  CommandIcon.Night,
  CommandIcon.Entrance,
  CommandIcon.Exit,
];

export const SymbolsLockCommandIcons = [
  CommandIcon.Key,
  CommandIcon.Generic2,
  CommandIcon.Generic3,
  CommandIcon.Generic4,
  CommandIcon.Generic5,
  CommandIcon.Generic6,
  CommandIcon.Generic7,
  CommandIcon.Generic8,
  CommandIcon.Generic9,
  CommandIcon.Day,
  CommandIcon.Night,
  CommandIcon.Entrance,
  CommandIcon.Exit,
];

export const SymbolsSceneCommandIcons = [
  CommandIcon.Key,
  CommandIcon.Generic2,
  CommandIcon.Generic3,
  CommandIcon.Generic4,
  CommandIcon.Generic5,
  CommandIcon.Generic6,
  CommandIcon.Generic7,
  CommandIcon.Generic8,
  CommandIcon.Generic9,
  CommandIcon.Day,
  CommandIcon.Night,
  CommandIcon.Entrance,
  CommandIcon.Exit,
];

export const NumbersCommandIcons = [
  CommandIcon.Zero,
  CommandIcon.One,
  CommandIcon.Two,
  CommandIcon.Three,
  CommandIcon.Four,
  CommandIcon.Five,
  CommandIcon.Six,
  CommandIcon.Seven,
  CommandIcon.Eight,
  CommandIcon.Nine,
];

export const LettersCommandIcons = [
  CommandIcon.A,
  CommandIcon.B,
  CommandIcon.C,
  CommandIcon.D,
  CommandIcon.E,
  CommandIcon.F,
  CommandIcon.G,
  CommandIcon.H,
  CommandIcon.I,
  CommandIcon.J,
  CommandIcon.K,
  CommandIcon.L,
  CommandIcon.M,
  CommandIcon.N,
  CommandIcon.O,
  CommandIcon.P,
  CommandIcon.Q,
  CommandIcon.R,
  CommandIcon.S,
  CommandIcon.T,
  CommandIcon.U,
  CommandIcon.V,
  CommandIcon.W,
  CommandIcon.X,
  CommandIcon.Y,
  CommandIcon.Z,
];
